import React, { useState } from 'react';
import { Moon, Menu, X } from 'lucide-react';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);

  return (
    <nav className="bg-slate-50/80 backdrop-blur-sm shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <a href="/" className="flex items-center space-x-2">
            <Moon className="text-amber-400 w-6 h-6" />
            <span className="text-xl md:text-2xl font-semibold text-slate-800">Etoile Veilleuse</span>
          </a>
          
          {/* Navigation desktop */}
          <div className="hidden md:flex space-x-6 text-slate-600">
            <a href="/" className="hover:text-amber-500 transition-colors">Accueil</a>
            
            {/* Dropdown Services */}
            <div className="relative group">
              <button 
                className="hover:text-amber-500 flex items-center transition-colors"
                onMouseEnter={() => setShowServicesDropdown(true)}
                onMouseLeave={() => setShowServicesDropdown(false)}
              >
                Services
                <span className="ml-1 text-xs">▼</span>
              </button>
              <div 
                className={`absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl transition-all duration-200 ${
                  showServicesDropdown ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'
                }`}
                onMouseEnter={() => setShowServicesDropdown(true)}
                onMouseLeave={() => setShowServicesDropdown(false)}
              >
                <a href="/nurse-nuit" className="block px-4 py-3 text-slate-600 hover:bg-amber-50 hover:text-amber-500 transition-colors rounded-t-lg">
                  Nurse de Nuit
                </a>
                <a href="/nurse-jour" className="block px-4 py-3 text-slate-600 hover:bg-amber-50 hover:text-amber-500 transition-colors border-t border-slate-100">
                  Nurse de Jour
                </a>
                <a href="/accompagnement-parental" className="block px-4 py-3 text-slate-600 hover:bg-amber-50 hover:text-amber-500 transition-colors border-t border-slate-100 rounded-b-lg">
                  Accompagnement Parental
                </a>
              </div>
            </div>
            
            <a href="/ConseilsPage" className="hover:text-amber-500 transition-colors">Conseils Parents</a>
            <a href="/about" className="hover:text-amber-500 transition-colors">Qui Sommes-Nous</a>
            <a href="/legal" className="hover:text-amber-500 transition-colors">Protection & CGU</a>
          </div>
          
          {/* Bouton menu mobile */}
          <button
            className="md:hidden text-slate-600 hover:text-amber-500"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Menu mobile */}
        {isMenuOpen && (
          <div className="mt-4 space-y-2 md:hidden">
            <a href="/" className="block text-slate-600 hover:text-amber-500 py-2">Accueil</a>
            
            <div className="border-t border-slate-200 pt-2">
              <p className="text-sm font-semibold text-slate-700 mb-2">Nos Services</p>
              <a href="/nurse-nuit" className="block text-slate-600 hover:text-amber-500 pl-4 py-2">Nurse de Nuit</a>
              <a href="/nurse-jour" className="block text-slate-600 hover:text-amber-500 pl-4 py-2">Nurse de Jour</a>
              <a href="/accompagnement-parental" className="block text-slate-600 hover:text-amber-500 pl-4 py-2">Accompagnement Parental</a>
            </div>
            
            <div className="border-t border-slate-200 pt-2">
              <a href="/ConseilsPage" className="block text-slate-600 hover:text-amber-500 py-2">Conseils Parents</a>
              <a href="/about" className="block text-slate-600 hover:text-amber-500 py-2">Qui Sommes-Nous</a>
              <a href="/legal" className="block text-slate-600 hover:text-amber-500 py-2">Protection & CGU</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;